<template>
  <BaseDataTable :data="facebookCampaigns">
    <template #header>
      <FacebookCampaignListHeader />
    </template>

    <template #default="{ item }">
      <FacebookCampaignListItem
        :project-id="projectId"
        :account-id="accountId"
        :facebook-campaign="item"
        :facebook-campaign-insights="getInsightsByFacebookCampaignId(item.id)"
        :key="item.id"
        @removed="fetchFacebookCampaigns()"
      />
    </template>
  </BaseDataTable>
</template>

<script>
import apiFetch from '@/api/clients';
import FacebookCampaignListHeader from './FacebookCampaignListHeader.vue';
import FacebookCampaignListItem from './FacebookCampaignListItem.vue';

export default {
  components: {
    FacebookCampaignListHeader,
    FacebookCampaignListItem,
  },
  props: {
    accountId: {
      type: String,
      required: true,
    },
    projectId: {
      type: String,
      required: true,
    },
    range: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      facebookCampaigns: [],
      facebookCampaignInsights: [],
    };
  },
  watch: {
    range() {
      this.fetchFacebookCampaignInsights();
    },
  },
  mounted() {
    this.fetchFacebookCampaigns();
  },
  methods: {
    async fetchFacebookCampaigns() {
      this.facebookCampaigns = await apiFetch
        .get(`/projects/${this.projectId}/facebook-campaigns`)
        .then((response) => response.data.data);

      if (this.facebookCampaigns.length === 0) {
        return;
      }

      this.fetchFacebookCampaignInsights();
    },
    async fetchFacebookCampaignInsights() {
      const [since, until] = this.range;
      this.facebookCampaignInsights = await apiFetch
        .get(`/accounts/${this.accountId}/facebook-campaign-insights`, {
          params: {
            include: 'contact_requests_count',
            filter: {
              id: this.facebookCampaigns.map((item) => item.id),
              ...(since && until ? { since, until } : {}),
            },
            aggregated: 1,
          },
        })
        .then((response) => response.data.data);
    },
    getInsightsByFacebookCampaignId(facebookCampaignId) {
      return this.facebookCampaignInsights.find(
        (item) => item.facebook_campaign_id === facebookCampaignId
      );
    },
  },
};
</script>
